import { Card, Typography, Drawer, Button, Tooltip, notification, Icon, Alert } from "antd";
import React from "react";
import { TableComp } from "sz-react-utils";
import Request, { MEDIA_URL } from "../../request";
import moment from "moment";
const dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
const companyDetails = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')) : {};
const companyCurrency = companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : 'INR';
const { Title, Text } = Typography;


class BranchPaidInvoiceDrawer extends React.Component {
    state = {
        visible: true,
        loading: false
    }

    constructor(props) {
        super(props)
        this.table = React.createRef();
    }

    onClose = () => {
        this.setState({ visible: false });
        setTimeout(() => {
            this.props.onClose();
        }, 50)
    }

    apiRequest = () => {
        return new Promise(async (resolve) => {
            let response = await Request.getPaidBranchInvoiceCount();
            if (response.total === 0) {
                this.onClose();
            }
            return resolve(response);
        })
    }


    handleUpdateStatus = async (recordId, status) => {
        this.setState({ loading: true });
        let response = await Request.updateBranchPaidInvoiceStatus({ _id: recordId, receivedStatus: status });
        this.setState({ loading: false });
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        this.table.current.reload();
    }


    render() {
        let { visible, loading } = this.state;
        const currencySymbols = {
            USD: "$",      // US Dollar
            EUR: "€",      // Euro
            GBP: "£",      // British Pound
            INR: "₹",      // Indian Rupee
            AUD: "A$",     // Australian Dollar
            CAD: "C$",     // Canadian Dollar
            JPY: "¥",      // Japanese Yen
            CNY: "¥",      // Chinese Yuan
            NZD: "NZ$",    // New Zealand Dollar
            CHF: "CHF",    // Swiss Franc
            SGD: "S$",     // Singapore Dollar
            HKD: "HK$",    // Hong Kong Dollar
            SEK: "kr",     // Swedish Krona
            NOK: "kr",     // Norwegian Krone
            DKK: "kr",     // Danish Krone
            ZAR: "R",      // South African Rand
            AED: "د.إ",    // UAE Dirham
            SAR: "﷼",     // Saudi Riyal
            THB: "฿",      // Thai Baht
            MYR: "RM",     // Malaysian Ringgit
            IDR: "Rp",     // Indonesian Rupiah
            KRW: "₩",      // South Korean Won
            TRY: "₺",      // Turkish Lira
            RUB: "₽",      // Russian Ruble
            BRL: "R$",     // Brazilian Real
            MXN: "$",      // Mexican Peso
            PHP: "₱",      // Philippine Peso
            PLN: "zł",     // Polish Zloty
            HUF: "Ft",     // Hungarian Forint
            CZK: "Kč",     // Czech Koruna
        };
        const columns = [
            {
                title: 'Action',
                key: 'action',
                width: 100,
                align: 'center',
                render: (text, record) => (
                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', alignItems: 'center' }}>
                        <Tooltip title="Approve">
                            <Button
                                loading={loading}
                                icon="check"
                                shape="circle"
                                size="small"
                                type="primary"
                                style={{ background: '#52c41a', borderColor: '#52c41a', color: '#fff' }}
                                onClick={() => this.handleUpdateStatus(record._id, "Approved")}
                            />
                        </Tooltip>

                        <Tooltip title="Disapprove">
                            <Button
                                loading={loading}
                                icon="close"
                                shape="circle"
                                size="small"
                                type="danger"
                                onClick={() => this.handleUpdateStatus(record._id, "Disapproved")}
                            />
                        </Tooltip>
                    </div>
                )
            },
            {
                title: 'Sr. No',
                key: 'serialNumber',
                width: 60,
                align: 'center',
                render: (text, record, index) => (
                    <div style={{ fontWeight: 600, color: '#666' }}>{index + 1}</div>
                )
            },
            {
                title: 'Invoice Details',
                key: 'invoiceNumber',
                width: 260,
                render: (text, record) => {
                    var branchInvNum = record && record.branchInvoiceNumber ? record.branchInvoiceNumber : '-';
                    var claimNum = record && record.claimNumber ? record.claimNumber : '-';
                    var invUrl = record && record.invoiceUrl ? record.invoiceUrl : null;

                    // Payment date calculation parameters setup safely
                    var rawDate = record && record.paymentDate ? (record.paymentDate.$date ? record.paymentDate.$date : record.paymentDate) : null;
                    var formattedPaymentDate = rawDate ? moment(rawDate).format(dateFormat) : null;

                    var receipts = record && record.paymentReceipt ? record.paymentReceipt : [];
                    var singleReceiptUrl = receipts.length > 0 && receipts[0].url ? receipts[0].url : null;

                    // ─── ✅ PAID BY USER DETAILS MAPPING ─────────────────────────
                    var paidUser = record && record.paidByUser ? record.paidByUser : null;
                    var paidByName = paidUser && paidUser.name ? paidUser.name : null;
                    var paidAtTime = '';
                    if (paidUser && paidUser.time) {
                        var rawPaidTime = paidUser.time.$date ? paidUser.time.$date : paidUser.time;
                        paidAtTime = moment(rawPaidTime).format('DD/MM/YY HH:mm');
                    }

                    // Fallback to standard creator info if paidByUser doesn't exist
                    var createdUser = record && record.createdByUser ? record.createdByUser : null;
                    var createdByName = createdUser && createdUser.name ? createdUser.name : '-';

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <span style={{ fontWeight: 700, color: '#141414', fontSize: '14px' }}>
                                {invUrl ? (
                                    <a href={`${MEDIA_URL}${invUrl}`} target="_blank" rel="noopener noreferrer" style={{ color: '#096dd9', textDecoration: 'none', borderBottom: '1px dashed #096dd9' }}>
                                        Inv#: {branchInvNum}
                                    </a>
                                ) : "Inv#: " + branchInvNum}
                            </span>

                            <span style={{ fontSize: '11px', color: '#8c8c8c' }}>
                                Claim No: {claimNum}
                            </span>

                            <div style={{
                                marginTop: '4px',
                                paddingTop: '4px',
                                borderTop: '1px dashed #e8e8e8',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '2px',
                                fontSize: '11px',
                                color: '#595959'
                            }}>
                                {formattedPaymentDate && (
                                    <div>
                                        <Icon type="calendar" style={{ marginRight: 5, color: '#bfbfbf' }} />
                                        Paid On: <strong>{formattedPaymentDate}</strong>
                                    </div>
                                )}
                                <div style={{ display: 'flex', gap: '10px', marginTop: '2px', marginBottom: '4px' }}>
                                    {invUrl && (
                                        <a href={`${MEDIA_URL}${invUrl}`} target="_blank" rel="noopener noreferrer" style={{ color: '#13c2c2', fontWeight: 500 }}>
                                            <Icon type="file-pdf" style={{ marginRight: 3 }} /> View Invoice
                                        </a>
                                    )}
                                    {singleReceiptUrl && (
                                        <a href={`${MEDIA_URL}${singleReceiptUrl}`} target="_blank" rel="noopener noreferrer" style={{ color: '#722ed1', fontWeight: 500 }}>
                                            <Icon type="file-done" style={{ marginRight: 3 }} /> Receipt
                                        </a>
                                    )}
                                </div>
                            </div>

                            {/* ✅ System Trace Logs: Priority displays Paid By info with Datetime stamp */}
                            <div style={{
                                marginTop: '2px',
                                fontSize: '11px',
                                color: '#8c8c8c',
                                borderTop: '1px solid #f5f5f5',
                                paddingTop: '4px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '1px'
                            }}>
                                {paidByName ? (
                                    <React.Fragment>
                                        <div>
                                            <Icon type="check-circle" style={{ marginRight: 4, color: '#52c41a' }} />
                                            Paid By: <span style={{ color: '#262626', fontWeight: 600 }}>{paidByName}</span>
                                        </div>
                                        {paidAtTime && (
                                            <div style={{ fontSize: '10px', color: '#bfbfbf', paddingLeft: '16px', fontStyle: 'italic' }}>
                                                {paidAtTime}
                                            </div>
                                        )}
                                    </React.Fragment>
                                ) : (
                                    <div>
                                        <Icon type="user" style={{ marginRight: 4, color: '#bfbfbf' }} />
                                        By: <span style={{ color: '#595959', fontWeight: 500 }}>{createdByName}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                }
            },
            {
                title: 'Student & Course Details',
                key: 'studentCourseDetails',
                width: 340,
                render: (text, record) => {
                    var studentsList = record && record.studentDetails ? record.studentDetails : [];
                    var companySymbol = currencySymbols[companyCurrency] ? currencySymbols[companyCurrency] : companyCurrency + ' ';

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {studentsList.map((student, idx) => {
                                var studentCurrency = student.currency ? student.currency : 'EUR';
                                var sym = currencySymbols[studentCurrency] ? currencySymbols[studentCurrency] : studentCurrency + ' ';

                                var currentTerm = student.termNumber ? student.termNumber : '1';

                                var rawComm = student.commissionTotal ? Number(student.commissionTotal) : 0;
                                var rawGrossINR = student.grossPaymentReceived ? Number(student.grossPaymentReceived) : 0;
                                var rawAssociateINR = student.associateAmount ? Number(student.associateAmount) : 0;
                                var rateSharing = student.sharingRate ? student.sharingRate : '-';
                                var studentConversion = student.conversionRate ? student.conversionRate : '-';

                                return (
                                    <div key={idx} style={{
                                        padding: '12px',
                                        background: '#fafafa',
                                        borderRadius: '8px',
                                        border: '1px solid #e8e8e8',
                                        borderBottom: idx !== studentsList.length - 1 ? '1px dashed #bfbfbf' : '1px solid #e8e8e8',
                                        lineHeight: '22px'
                                    }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                                            <span style={{ fontWeight: 700, color: '#1677ff', fontSize: '14px' }}>
                                                <Icon type="user" style={{ marginRight: 6 }} />
                                                {student.studentName}
                                            </span>
                                            <span style={{
                                                fontSize: '11px',
                                                fontWeight: 700,
                                                color: '#096dd9',
                                                background: '#e6f7ff',
                                                border: '1px solid #91d5ff',
                                                padding: '1px 6px',
                                                borderRadius: '4px'
                                            }}>
                                                T{currentTerm}
                                            </span>
                                        </div>

                                        <div style={{ fontSize: '11px', color: '#8c8c8c' }}>
                                            <b>VID:</b> {student.studentVisionId || '-'} | <b>Passport:</b> {student.passportNumber || '-'}
                                        </div>

                                        <div style={{ fontWeight: 600, color: '#262626', marginTop: '6px', fontSize: '12px' }}>
                                            <Icon type="bank" style={{ marginRight: 6, color: '#bfbfbf' }} />
                                            {student.universityInstitutionName || '-'}
                                        </div>
                                        <div style={{ fontSize: '11px', color: '#595959', fontStyle: 'italic', marginBottom: '8px' }}>
                                            {student.courseName}
                                        </div>

                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '2px',
                                            background: '#fff',
                                            padding: '8px',
                                            borderRadius: '6px',
                                            border: '1px dashed #d9d9d9',
                                            fontSize: '11px'
                                        }}>
                                            <div><b>Comm (Foreign):</b> {sym}{rawComm.toFixed(2)}</div>
                                            <div><b>Gross Total:</b> {companySymbol}{rawGrossINR.toFixed(2)}</div>
                                            <div style={{ color: '#237804', fontWeight: 600, borderTop: '1px dashed #f0f0f0', marginTop: '4px', paddingTop: '2px' }}>
                                                <b>Branch Share ({rateSharing}):</b> {companySymbol}{rawAssociateINR.toFixed(2)}
                                            </div>
                                            <div style={{ color: '#8c8c8c', fontSize: '10px', marginTop: '2px' }}>
                                                <Icon type="swap" style={{ marginRight: 4 }} />
                                                Ex Rate: 1 {studentCurrency} = {studentConversion} INR
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    );
                }
            },
            {
                title: 'Financial Breakdown',
                key: 'financialBreakdown',
                width: 250,
                render: (text, record) => {
                    var companySymbol = currencySymbols[companyCurrency] ? currencySymbols[companyCurrency] : companyCurrency + ' ';

                    var amountBeforeTax = record && record.amountBeforeTax ? Number(record.amountBeforeTax) : 0;
                    var amountAfterTax = record && record.amountAfterTax ? Number(record.amountAfterTax) : 0;
                    var totalFinalPayout = record && record.totalAfterAdditionalDeduction ? Number(record.totalAfterAdditionalDeduction) : 0;

                    var taxDetails = record && record.taxDetails ? record.taxDetails : [];
                    var deductionDetails = record && record.additionalDeductionDetail ? record.additionalDeductionDetail : [];

                    return (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '5px',
                            padding: '10px',
                            background: '#fff',
                            border: '1px solid #e8e8e8',
                            borderRadius: '8px',
                            boxShadow: '0 1px 4px rgba(0,0,0,0.02)'
                        }}>
                            <div style={{ fontSize: '12px', color: '#595959' }}>
                                <span style={{ color: '#8c8c8c', marginRight: 4 }}>Amt Before Tax:</span>
                                <strong>{companySymbol}{amountBeforeTax.toFixed(2)}</strong>
                            </div>

                            {taxDetails.map((tax, idx) => (
                                <div key={idx} style={{ fontSize: '11px', color: '#434343', paddingLeft: '8px' }}>
                                    <span style={{ color: '#8c8c8c', marginRight: 4 }}>+ {tax.taxName} ({tax.taxValue}%):</span>
                                    {companySymbol}{Number(tax.taxAmount || 0).toFixed(2)}
                                </div>
                            ))}

                            <div style={{ fontSize: '12px', color: '#595959', borderTop: '1px dashed #f0f0f0', paddingTop: '4px' }}>
                                <span style={{ color: '#8c8c8c', marginRight: 4 }}>Amt After Tax:</span>
                                {companySymbol}{amountAfterTax.toFixed(2)}
                            </div>

                            {deductionDetails.map((ded, idx) => (
                                <div key={idx} style={{ fontSize: '11px', color: '#ff4d4f', paddingLeft: '8px' }}>
                                    <span style={{ color: '#bfbfbf', marginRight: 4 }}>{ded.taxName} ({ded.taxValue}%):</span>
                                    {companySymbol}{Number(ded.taxAmount || 0).toFixed(2)}
                                </div>
                            ))}

                            <div style={{
                                fontSize: '13px',
                                fontWeight: 700,
                                color: '#237804',
                                borderTop: '1px solid #e8e8e8',
                                paddingTop: '6px',
                                marginTop: '2px'
                            }}>
                                <span style={{ fontSize: '11px', color: '#8c8c8c', fontWeight: 500, marginRight: 4 }}>Net Payable Amount:</span>
                                <div style={{ fontSize: '16px', fontWeight: 800, color: '#52c41a', marginTop: '2px' }}>
                                    {companySymbol}{totalFinalPayout.toFixed(2)}
                                </div>
                            </div>
                        </div>
                    );
                }
            },
            {
                title: 'Invoice Status',
                key: 'invoiceStatus',
                width: 130,
                align: 'center',
                render: (text, record) => {
                    var status = record && record.status ? record.status : 'PENDING';

                    var getStatusColors = function (currentStatus) {
                        var s = currentStatus ? currentStatus.toUpperCase() : 'PENDING';
                        var config = {
                            'PENDING': { color: '#faad14', bg: '#fffbe6', border: '#ffe58f' },
                            'PAID': { color: '#52c41a', bg: '#f6ffed', border: '#b7eb8f' },
                            'APPROVED': { color: '#389e0d', bg: '#f6ffed', border: '#b7eb8f' },
                            'UNDER REVIEW': { color: '#1890ff', bg: '#e6f7ff', border: '#91d5ff' }
                        };
                        return config[s] || { color: '#595959', bg: '#f5f5f5', border: '#d9d9d9' };
                    };

                    var mainStyles = getStatusColors(status);

                    return (
                        <span style={{
                            fontSize: '11px',
                            fontWeight: 700,
                            color: mainStyles.color,
                            background: mainStyles.bg,
                            border: '1px solid ' + mainStyles.border,
                            padding: '2px 8px',
                            borderRadius: '12px',
                            textTransform: 'uppercase'
                        }}>
                            {status}
                        </span>
                    );
                }
            }
        ];
        return (
            <Drawer
                title={
                    <Title
                        level={4}
                        style={{ marginBottom: 0 }}
                    >
                        Paid Invoices
                    </Title>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={1000}
                visible={visible}
            >
                <Card bordered={true}>
                    <Alert
                        message="Branch Payment Confirmation & Verification"
                        description={
                            <ul style={{ paddingLeft: '15px', marginBottom: 0 }}>
                                <li><strong>Verify Payment Receipt:</strong> Please carefully open and check the attached <strong>Receipt</strong> file to confirm the transaction details from the finance team.</li>
                                <li><strong>Confirm Bank Credit:</strong> Ensure that the net branch share amount has been accurately credited to your bank account records before updating.</li>
                                <li><strong>Mark Received:</strong> After full cross-confirmation and finding everything in order, click the check icon to mark the invoice payout as <strong>Received / Approved</strong>.</li>
                            </ul>
                        }
                        type="info"
                        showIcon
                        style={{ marginBottom: '20px' }}
                    />
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: false,
                            defaultPageSize: 200,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>

            </Drawer>
        )
    }
}



export default BranchPaidInvoiceDrawer;